import { render, staticRenderFns } from "./ContractToSign.vue?vue&type=template&id=c13ad2b8&scoped=true&"
import script from "./ContractToSign.vue?vue&type=script&lang=ts&"
export * from "./ContractToSign.vue?vue&type=script&lang=ts&"
import style0 from "./ContractToSign.vue?vue&type=style&index=0&id=c13ad2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13ad2b8",
  null
  
)

export default component.exports